// Components
import TopCreatorsCarousel from 'components/Athlete/TopCreatorsCarousel/TopCreatorsCarousel';
// Styles
import styles from './SuggestedCreators.module.scss';

/**
 * Component that displays suggested top creators when there's no content to show.
 * This component is only rendered when there's no content and the owner is not in featured streams.
 * The check for featured streams participation is done in the parent TabsNavigation component.
 */
const SuggestedCreators = () => {
  return (
    <div className={styles.root}>
      <TopCreatorsCarousel />
    </div>
  );
};
export default SuggestedCreators;
